/**
 * User detail bulk update (hubadmin/user-detail-update-types, hubadmin/update-user-details)
 */

export interface UserDetailUpdateType {
  id: number;
  code: string;
  label: string;
  single_fields: string[];
  bulk_headers: string[];
  optional_fields: string[];
}

export interface UserDetailUpdateMode {
  id: number;
  code: string;
  label: string;
}

export interface UserDetailUpdateTypesResponse {
  types: UserDetailUpdateType[];
  update_modes: UserDetailUpdateMode[];
}

/** Bulk update_mode id from API (code: bulk) */
export const USER_DETAIL_UPDATE_MODE_BULK = 2;

export interface UserDetailUpdateRejectedRow {
  s_no: number;
  rejected_reason: string;
  [field: string]: string | number;
}

export interface UserDetailUpdateSubmitResponse {
  total_count: number;
  rejected_count: number;
  rejected_reasons: UserDetailUpdateRejectedRow[];
  /** Legacy / optional fields from older API shape */
  message?: string;
  approve_count?: number;
}
